import React, { Component } from 'react'

export const Loading = ({ isFetching = true }) => {
  if (isFetching) return <i className="fa fa-spin fa-spinner" style={styles} />
  return null
}

export default Loading

const styles = {
  position: 'absolute',
  color: '#01A8E7',
  left: '50%',
  top: '50%',
  transform: 'translate(50%, 50%)',
  fontSize: 50,
  width: 50,
  height: 50,
}
